export enum StackAlignment {
  Left = 'left',
  Center = 'center',
}

export default StackAlignment;
